import { Link } from 'react-router-dom';
import { Logo } from '@/components/brand/Logo';
import { EulaDocument } from '@/components/legal/EulaDocument';
import {
  CURRENT_EULA_LAST_UPDATED_DISPLAY,
  CURRENT_EULA_VERSION,
} from '@/lib/eula';

/**
 * Public-facing End-User License Agreement.
 *
 * Hosted at /legal/eula (alias /eula). Must remain reachable without
 * authentication so external reviewers (e.g. Intuit / QBO production-app
 * onboarding, counsel, prospective contractors) can fetch a stable URL.
 *
 * The document body lives in src/components/legal/EulaDocument.tsx and is
 * shared with the click-through acceptance gate so users never see a
 * different version of the agreement than what's publicly published.
 *
 * Version metadata + email constants live in src/lib/eula.ts.
 */
export function EulaPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border bg-card">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-3" aria-label="Virro Atlas">
            <Logo variant="primary" tone="humus" className="h-7" />
          </Link>
          <Link
            to="/auth/sign-in"
            className="text-xs font-medium text-muted-foreground transition-colors hover:text-foreground"
          >
            Sign in
          </Link>
        </div>
      </header>

      <article className="mx-auto max-w-3xl px-6 py-12 leading-body">
        <EulaDocument />
      </article>

      <footer className="border-t border-border">
        <div className="mx-auto flex max-w-3xl flex-col gap-2 px-6 py-8 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>
            &copy; {new Date().getFullYear()} Eloo LLC d/b/a Virro Life. All
            rights reserved.
          </p>
          <p>
            EULA {CURRENT_EULA_VERSION} · Last updated{' '}
            {CURRENT_EULA_LAST_UPDATED_DISPLAY}
          </p>
        </div>
      </footer>
    </div>
  );
}
